module.exports = __webpack_public_path__ + "img/10.0c38290e.jpg";